import { EstadoVerificacion } from '@/shared/model/enumerations/estado-verificacion';

export interface IEventoVerificacion {
  estado?: EstadoVerificacion | null;
  cvu?: number | null;
  fecha?: Date | null;
  activo?: boolean | null;
}

export class EventoVerificacion implements IEventoVerificacion {
  constructor(
    public estadoNomina?: EstadoVerificacion | null,
    public cvu?: number | null,
    public fecha?: Date | null,
    public activo?: boolean | null
  ) {}

  static fromObject(data: IEventoVerificacion): EventoVerificacion {
    const eventoVerificacion = new EventoVerificacion();
    for (const [key, value] of Object.entries(data)) {
      eventoVerificacion[key] = value;
    }
    return eventoVerificacion;
  }
}
